import { useState } from 'react'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import Tabs from '../../ui-components/Tabs'
import TrailingReturnsPerformanceSection from './TRPerformance'
import PeersSection from '../../peers/PeersSection'
import RankSection from '../../rank/RankSection'

enum TRTabs {
  PERFORMANCE = 'Returns',
  RANK = 'Rank Trend',
  PEERS = 'Leaderboard'
}

const TR_TAB_ID_PREFIX = 'trailing-returns-tab'
const TR_TAB_PANEL_ID = `${TR_TAB_ID_PREFIX}-panel`

export default function TrailingReturnsBody() {
  const [selectedTabId, setSelectedTabId] = useState<`${TRTabs}`>(TRTabs.PERFORMANCE)
  const { data: metadata } = useMetaDataContext()

  return (
    <div className='flex flex-col w-full pt-[11px]'>
      <div className='pb-[24px] w-full'>
        <div className='h-11'>
          <Tabs
            selectedTabId={selectedTabId}
            tabButtonIdPrefix={TR_TAB_ID_PREFIX}
            tabsData={[
              { id: TRTabs.PERFORMANCE, label: TRTabs.PERFORMANCE },
              { id: TRTabs.RANK, label: TRTabs.RANK },
              { id: TRTabs.PEERS, label: TRTabs.PEERS }
            ]}
            onTabClick={(id) => setSelectedTabId(() => id as `${TRTabs}`)}
            isFullWidth
          />
        </div>
      </div>
      <div
        role='tabpanel'
        id={TR_TAB_PANEL_ID}
        aria-labelledby={`${TR_TAB_ID_PREFIX}-${selectedTabId}`}
      >
        {{
          [TRTabs.PERFORMANCE]: <TrailingReturnsPerformanceSection />,
          [TRTabs.RANK]: <RankSection ranksType='TRAILING' />,
          [TRTabs.PEERS]: (
            <PeersSection peersType='TRAILING' fundCategory={metadata?.fundDetails?.category ?? ''} />
          )
        }[selectedTabId] || <div className='h-[400px] w-full' />}
      </div>
    </div>
  )
}
